import { Directive, EventEmitter, Output, HostListener } from '@angular/core';
import { ImageFromClipboardEventService } from '../services/image-from-clipboard-event.service';

@Directive({
  selector: '[appPasteImage]'
})
export class PasteImageDirective {
 

  @Output() imagesPasted: EventEmitter<File[]> = new EventEmitter();

  constructor( private ifcService: ImageFromClipboardEventService ) {
  }

  @HostListener('window:paste', ['$event'])
  public onPaste( event: ClipboardEvent ) {

    const pastedImages = this.ifcService.getPastedImages( event );

    if ( ! pastedImages ) {
      return;
    }

    this.imagesPasted.emit( pastedImages );

    // When we create Object URLs, the browser will keep them in memory until the
    // document is unloaded or until the URL is explicitly released. Since we are
    // going to create a new URL every time the user pastes an image into the app (in
    // this particular demo), we need to be sure to release the previous Object URL
    // before we create the new one.
    // --
    // NOTE: One the Image is rendered in the DOM, releasing the Object URL will not
    // affect the rendering.
    // if ( this.lastObjectUrl ) {
    //   URL.revokeObjectURL( this.lastObjectUrl );
    // }

    // At this point, the "pastedImage" is a File object, which is a specialized type
    // of "Blob". We can now generate a "blob:" URL using the given File.
    // this.lastObjectUrl = URL.createObjectURL( pastedImage );

    // By default, Angular WILL NOT TRUST this "blob:" style URLs. However, since we
    // know these are going to be expected, we can use the DOM Sanitizer to bypass
    // the security checks on these images.
    // --
    // NOTE: The sanitizer doesn't return Strings - it returns SafeUrls.
    // this.imageUrls.unshift(
    //   this.sanitizer.bypassSecurityTrustUrl( this.lastObjectUrl )
    // );

  }
}
